import React from 'react'
import RenderSingleSegment from './RenderSingleSegment';

function RenderListSegmentedText({ handleStaticContentChange, list, changedParamBoundaries, isSelected, isEditing, editingSegmentId, openFilePreview, stateSync, spanRef, segmentation, inputValues, segmentsOverrides }) {
  const listType = list?.type ?? "bulleted-list";
  return (<>
    {
        listType === "bulleted-list" ? (<>
          <ul>
            {list.children.map((listElement, idx) => (
              <li key={idx} style={{ textAlign: listElement?.alignment ?? "left", width: "100%", marginBottom: "10px" }}>
                {listElement.children.map((segment, idx) => (
                  <RenderSingleSegment
                    key={segment.id}
                    segment={segment}
                    isSelected={isSelected}
                    changedParamBoundaries={changedParamBoundaries}
                    isEditing={isEditing}
                    editingSegmentId={editingSegmentId}
                    openFilePreview={openFilePreview}
                    handleStaticContentChange={handleStaticContentChange}
                    stateSync={stateSync}
                    spanRef={spanRef}
                    segmentIdx={(segment as any).actualIdx}
                    segmentation={segmentation}
                    inputValues={inputValues}
                    segmentsOverrides={segmentsOverrides}
                  />
                ))
                }
              </li>
            ))}
          </ul>
        </>) 
        : (<>
          <ol>
            {list.children.map((listElement, idx) => (
              <li key={idx} style={{ textAlign: listElement?.alignment ?? "left",width: "100%", marginBottom: "10px" }}>
                {listElement.children.map((segment, idx) => (
                  <RenderSingleSegment
                    key={segment.id}
                    segment={segment}
                    isSelected={isSelected}
                    changedParamBoundaries={changedParamBoundaries}
                    isEditing={isEditing}
                    editingSegmentId={editingSegmentId}
                    openFilePreview={openFilePreview}
                    handleStaticContentChange={handleStaticContentChange}
                    stateSync={stateSync}
                    spanRef={spanRef}
                    segmentIdx={(segment as any).actualIdx}
                    segmentation={segmentation}
                    inputValues={inputValues}
                    segmentsOverrides={segmentsOverrides}
                  />
                ))
                }
              </li>
            ))}
          </ol>
        </>)
      }
      </>
    )
}

export default RenderListSegmentedText